<template>
  <div class="login-header">
    <img class="top-logo" src="@/assets/images/common/header_welcome.png" alt="app_logo" width="60%" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">

.login-header {
  // background: linear-gradient(to right, #b9e6f1, #dcecd9, #e8f1e9);
  background-color: #d9f0d4;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding: 32px 16px 24px 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.login-title {
  font-size: 48px;
  font-weight: 800;
  color: $primary-text-color;
  margin: 0;
}

.login-subtitle {
  font-size: 14px;
  color: $primary-text-color;
  margin-top: 2px;
}
</style>
